import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-74b92ac6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "container-fluid"
};
var _hoisted_2 = {
  "class": "row align-items-center"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "col-lg-8 col-md-12"
  }, [/*#__PURE__*/_createElementVNode("h1", {
    "class": "text-white mb-2"
  }, "抹茶交易机器人分析"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-white mt-0 mb-4"
  }, " 跟踪 MEXC 机器人配置、订单状态、成交金额与盈利表现。 ")], -1);
});

var _hoisted_4 = {
  "class": "col-lg-4 text-lg-right"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 刷新数据 ");

var _hoisted_6 = {
  "class": "container-fluid mt--7"
};
var _hoisted_7 = {
  key: 0,
  "class": "card shadow"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-body text-center py-5"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "display-4 mb-3"
  }, "🔒"), /*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-2"
  }, "暂无访问权限"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-muted mb-0"
  }, " 抹茶交易机器人分析仅登录帐号 boylikegirl 可查看。 ")], -1);
});

var _hoisted_9 = [_hoisted_8];
var _hoisted_10 = {
  "class": "card shadow mb-4"
};
var _hoisted_11 = {
  "class": "card-body"
};
var _hoisted_12 = {
  "class": "row"
};
var _hoisted_13 = {
  "class": "col-lg-3 col-md-6 mb-3"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form-control-label"
  }, "交易对", -1);
});

var _hoisted_15 = {
  "class": "col-lg-3 col-md-6 mb-3"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form-control-label"
  }, "API 帐号", -1);
});

var _hoisted_17 = {
  "class": "col-lg-2 col-md-6 mb-3"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form-control-label"
  }, "订单状态", -1);
});

var _hoisted_19 = {
  "class": "col-lg-2 col-md-6 mb-3"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form-control-label"
  }, "内部状态", -1);
});

var _hoisted_21 = {
  "class": "col-lg-2 col-md-6 mb-3"
};

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    "class": "form-control-label"
  }, "分析样本", -1);
});

var _hoisted_23 = {
  key: 0,
  "class": "card shadow mb-4"
};
var _hoisted_24 = {
  "class": "card-body text-center text-muted"
};

var _hoisted_25 = /*#__PURE__*/_createTextVNode(" 正在加载交易机器人数据");

var _hoisted_26 = {
  key: 0
};

var _hoisted_27 = /*#__PURE__*/_createTextVNode("... ");

var _hoisted_28 = {
  "class": "row"
};
var _hoisted_29 = {
  "class": "card card-stats shadow"
};
var _hoisted_30 = {
  "class": "card-body"
};
var _hoisted_31 = {
  "class": "row"
};
var _hoisted_32 = {
  "class": "col"
};
var _hoisted_33 = {
  "class": "card-title text-uppercase text-muted mb-0"
};
var _hoisted_34 = {
  "class": "h2 font-weight-bold mb-0"
};
var _hoisted_35 = {
  "class": "col-auto"
};
var _hoisted_36 = {
  "class": "mt-3 mb-0 text-sm text-muted"
};
var _hoisted_37 = {
  "class": "row"
};
var _hoisted_38 = {
  "class": "col-xl-8 mb-4"
};
var _hoisted_39 = {
  "class": "card shadow h-100"
};

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "盈利与成交趋势"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-muted text-sm mb-0"
  }, " 按创建日期汇总：柱形为成交金额，折线为每日盈利、累计盈利与套牢订单数。 ")], -1);
});

var _hoisted_41 = {
  "class": "card-body"
};
var _hoisted_42 = {
  ref: "profitTrendChart",
  "class": "chart-panel"
};
var _hoisted_43 = {
  "class": "col-xl-4 mb-4"
};
var _hoisted_44 = {
  "class": "card shadow h-100"
};

var _hoisted_45 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "订单状态占比"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-muted text-sm mb-0"
  }, "按当前样本订单数统计。")], -1);
});

var _hoisted_46 = {
  "class": "card-body"
};
var _hoisted_47 = {
  ref: "statusPieChart",
  "class": "chart-panel"
};
var _hoisted_48 = {
  "class": "row"
};
var _hoisted_49 = {
  "class": "col-xl-8 mb-4"
};
var _hoisted_50 = {
  "class": "card shadow h-100"
};

var _hoisted_51 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "交易对盈利折线"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-muted text-sm mb-0"
  }, " 展示订单量最高的前 5 个交易对每日盈利。 ")], -1);
});

var _hoisted_52 = {
  "class": "card-body"
};
var _hoisted_53 = {
  ref: "symbolProfitLineChart",
  "class": "chart-panel"
};
var _hoisted_54 = {
  "class": "col-xl-4 mb-4"
};
var _hoisted_55 = {
  "class": "card shadow h-100"
};

var _hoisted_56 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "交易对订单占比"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-muted text-sm mb-0"
  }, "按交易对统计订单数量。")], -1);
});

var _hoisted_57 = {
  "class": "card-body"
};
var _hoisted_58 = {
  ref: "symbolPieChart",
  "class": "chart-panel"
};
var _hoisted_59 = {
  "class": "row"
};
var _hoisted_60 = {
  "class": "col-xl-4 mb-4"
};
var _hoisted_61 = {
  "class": "card shadow h-100"
};

var _hoisted_62 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "订单状态分布")], -1);
});

var _hoisted_63 = {
  "class": "card-body"
};
var _hoisted_64 = {
  "class": "bar-meta"
};
var _hoisted_65 = {
  "class": "bar-track"
};
var _hoisted_66 = {
  "class": "col-xl-4 mb-4"
};
var _hoisted_67 = {
  "class": "card shadow h-100"
};

var _hoisted_68 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "交易对热度")], -1);
});

var _hoisted_69 = {
  "class": "card-body"
};
var _hoisted_70 = {
  "class": "bar-meta"
};
var _hoisted_71 = {
  "class": "bar-track"
};
var _hoisted_72 = {
  "class": "col-xl-4 mb-4"
};
var _hoisted_73 = {
  "class": "card shadow h-100"
};

var _hoisted_74 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "交易对盈利排行")], -1);
});

var _hoisted_75 = {
  "class": "card-body"
};
var _hoisted_76 = {
  "class": "text-muted text-sm"
};
var _hoisted_77 = {
  "class": "row"
};
var _hoisted_78 = {
  "class": "col-xl-5 mb-4"
};
var _hoisted_79 = {
  "class": "card shadow h-100"
};

var _hoisted_80 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "套牢交易对排行"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-muted text-sm mb-0"
  }, " 买单已成交但内部状态未彻底结束的订单。 ")], -1);
});

var _hoisted_81 = {
  "class": "card-body"
};
var _hoisted_82 = {
  "class": "text-muted text-sm"
};
var _hoisted_83 = {
  "class": "text-danger"
};
var _hoisted_84 = {
  key: 0,
  "class": "text-muted text-sm"
};
var _hoisted_85 = {
  "class": "col-xl-7 mb-4"
};
var _hoisted_86 = {
  "class": "card shadow h-100"
};

var _hoisted_87 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "card-header border-0"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "套牢订单明细"), /*#__PURE__*/_createElementVNode("p", {
    "class": "text-muted text-sm mb-0"
  }, " 展示最近 20 单套牢订单，便于快速定位占用资金。 ")], -1);
});

var _hoisted_88 = {
  "class": "row"
};
var _hoisted_89 = {
  "class": "col-xl-12 mb-4"
};
var _hoisted_90 = {
  "class": "card shadow"
};
var _hoisted_91 = {
  "class": "card-header border-0"
};
var _hoisted_92 = {
  "class": "row align-items-center"
};

var _hoisted_93 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "col"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "mb-0"
  }, "最近订单")], -1);
});

var _hoisted_94 = {
  "class": "col text-right text-muted text-sm"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_button = _resolveComponent("base-button");

  var _component_base_header = _resolveComponent("base-header");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  var _component_el_tag = _resolveComponent("el-tag");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_base_header, {
    type: "gradient-success",
    "class": "pb-6 pt-2 pt-md-7"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [$options.canViewPage ? (_openBlock(), _createBlock(_component_base_button, {
        key: 0,
        type: "secondary",
        size: "sm",
        onClick: $options.loadData
      }, {
        "default": _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)])])])];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_6, [!$options.canViewPage ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_select, {
    modelValue: $data.filters.symbol,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.filters.symbol = $event;
    }),
    clearable: "",
    filterable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.symbolOptions, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item,
          label: item,
          value: item
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_select, {
    modelValue: $data.filters.cexName,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.filters.cexName = $event;
    }),
    clearable: "",
    filterable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cexNameOptions, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item,
          label: item,
          value: item
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_el_select, {
    modelValue: $data.filters.status,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.filters.status = $event;
    }),
    clearable: ""
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        label: "NEW",
        value: "NEW"
      }), _createVNode(_component_el_option, {
        label: "FILLED",
        value: "FILLED"
      }), _createVNode(_component_el_option, {
        label: "PARTIALLY_FILLED",
        value: "PARTIALLY_FILLED"
      }), _createVNode(_component_el_option, {
        label: "CANCELED",
        value: "CANCELED"
      })];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_el_select, {
    modelValue: $data.filters.innerStatus,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.filters.innerStatus = $event;
    }),
    clearable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.innerStatusOptions, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_component_el_select, {
    modelValue: $data.filters.sampleSize,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.filters.sampleSize = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        label: "最近 100 单",
        value: 100
      }), _createVNode(_component_el_option, {
        label: "最近 500 单",
        value: 500
      }), _createVNode(_component_el_option, {
        label: "最近 1000 单",
        value: 1000
      }), _createVNode(_component_el_option, {
        label: "最近 2000 单",
        value: 2000
      }), _createVNode(_component_el_option, {
        label: "全部订单",
        value: "all"
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])])]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, $data.loadedCount ? (_openBlock(), _createElementBlock("span", _hoisted_26, " ，已加载 " + _toDisplayString($data.loadedCount) + " 单", 1)) : _createCommentVNode("", true), _hoisted_27])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.metrics, function (metric) {
    return _openBlock(), _createElementBlock("div", {
      "class": "col-xl-3 col-md-6 mb-4",
      key: metric.label
    }, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("h5", _hoisted_33, _toDisplayString(metric.label), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(metric.value), 1)]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
      "class": _normalizeClass(["icon icon-shape text-white rounded-circle shadow", metric.color])
    }, [_createElementVNode("i", {
      "class": _normalizeClass(metric.icon)
    }, null, 2)], 2)])]), _createElementVNode("p", _hoisted_36, _toDisplayString(metric.help), 1)])])]);
  }), 128))]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, null, 512)])])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, null, 512)])])])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, null, 512)])])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, null, 512)])])])]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_hoisted_62, _createElementVNode("div", _hoisted_63, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.statusDistribution, function (item) {
    return _openBlock(), _createElementBlock("div", {
      "class": "bar-row",
      key: item.name
    }, [_createElementVNode("div", _hoisted_64, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("strong", null, _toDisplayString(item.count), 1)]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", {
      "class": "bar-fill bg-gradient-success",
      style: _normalizeStyle({
        width: item.percent + '%'
      })
    }, null, 4)])]);
  }), 128))])])]), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", _hoisted_69, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.symbolDistribution, function (item) {
    return _openBlock(), _createElementBlock("div", {
      "class": "bar-row",
      key: item.name
    }, [_createElementVNode("div", _hoisted_70, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("strong", null, _toDisplayString(item.count), 1)]), _createElementVNode("div", _hoisted_71, [_createElementVNode("div", {
      "class": "bar-fill bg-gradient-info",
      style: _normalizeStyle({
        width: item.percent + '%'
      })
    }, null, 4)])]);
  }), 128))])])]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_hoisted_74, _createElementVNode("div", _hoisted_75, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.profitBySymbol, function (item) {
    return _openBlock(), _createElementBlock("div", {
      "class": "profit-row",
      key: item.name
    }, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_76, _toDisplayString(item.count) + " 单", 1)]), _createElementVNode("span", {
      "class": _normalizeClass(item.profit >= 0 ? 'text-success' : 'text-danger')
    }, _toDisplayString($options.formatAmount(item.profit)), 3)]);
  }), 128))])])])]), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_hoisted_80, _createElementVNode("div", _hoisted_81, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.trappedBySymbol, function (item) {
    return _openBlock(), _createElementBlock("div", {
      "class": "profit-row",
      key: item.name
    }, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_82, _toDisplayString(item.count) + " 单 · 均价 " + _toDisplayString($options.formatAmount(item.avgPrice)), 1)]), _createElementVNode("span", _hoisted_83, _toDisplayString($options.formatAmount(item.amount)), 1)]);
  }), 128)), !$options.trappedBySymbol.length ? (_openBlock(), _createElementBlock("div", _hoisted_84, " 当前样本暂无套牢订单。 ")) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_hoisted_87, _createVNode(_component_el_table, {
    data: $options.trappedOrders.slice(0, 20),
    stripe: "",
    style: {
      "width": "100%"
    }
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "creationTime",
        label: "时间",
        width: "160"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatTime(scope.row.creationTime)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "symbol",
        label: "交易对",
        width: "120"
      }), _createVNode(_component_el_table_column, {
        prop: "cexName",
        label: "帐号",
        width: "120"
      }), _createVNode(_component_el_table_column, {
        prop: "price",
        label: "买入价",
        align: "right"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatAmount(scope.row.price)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "cummulativeQuoteQty",
        label: "套牢金额",
        align: "right"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatAmount($options.getOrderAmount(scope.row))), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "innerStatus",
        label: "内部状态",
        width: "120"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatInnerStatus(scope.row.innerStatus)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "套牢天数",
        width: "100",
        align: "right"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.getTrappedDays(scope.row)), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])])])]), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_hoisted_93, _createElementVNode("div", _hoisted_94, " 当前筛选共 " + _toDisplayString($data.totalCount) + " 单，已加载统计样本 " + _toDisplayString($data.orders.length) + " 单 ", 1)])]), _createVNode(_component_el_table, {
    data: $options.sortedOrders.slice(0, 50),
    stripe: "",
    style: {
      "width": "100%"
    }
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "creationTime",
        label: "时间",
        width: "170"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatTime(scope.row.creationTime)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "symbol",
        label: "交易对",
        width: "120"
      }), _createVNode(_component_el_table_column, {
        prop: "cexName",
        label: "帐号",
        width: "130"
      }), _createVNode(_component_el_table_column, {
        prop: "side",
        label: "方向",
        width: "80"
      }, {
        "default": _withCtx(function (scope) {
          return [_createVNode(_component_el_tag, {
            type: String(scope.row.side).toUpperCase() === 'BUY' ? 'success' : 'danger'
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString($options.formatSide(scope.row.side)), 1)];
            }),
            _: 2
          }, 1032, ["type"])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "status",
        label: "状态",
        width: "130"
      }, {
        "default": _withCtx(function (scope) {
          return [_createVNode(_component_el_tag, {
            type: $options.statusTagType(scope.row.status)
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(scope.row.status), 1)];
            }),
            _: 2
          }, 1032, ["type"])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "innerStatus",
        label: "内部状态",
        width: "110"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatInnerStatus(scope.row.innerStatus)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "price",
        label: "价格",
        align: "right"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatAmount(scope.row.price)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "quantity",
        label: "委托数量",
        align: "right"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatAmount(scope.row.quantity)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "cummulativeQuoteQty",
        label: "成交金额",
        align: "right"
      }, {
        "default": _withCtx(function (scope) {
          return [_createTextVNode(_toDisplayString($options.formatAmount(scope.row.cummulativeQuoteQty)), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "lastProfit",
        label: "最终盈利",
        align: "right"
      }, {
        "default": _withCtx(function (scope) {
          return [_createElementVNode("span", {
            "class": _normalizeClass(Number(scope.row.lastProfit) >= 0 ? 'text-success' : 'text-danger')
          }, _toDisplayString($options.formatAmount(scope.row.lastProfit)), 3)];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"])])])])], 64))])]);
}